import React, { ReactNode } from 'react';
import { PageContainer, PageTitle } from '../styles';
import { DocsTabItem } from '../types';
import { DocsTabs } from './tabs/DocsTabs';

interface DocsLayoutProps {
  tabs: DocsTabItem[];
  currentTab: number;
  onTabChange: (_event: React.ChangeEvent<{}>, newValue: number) => void;
  children: ReactNode;
  isSubPage?: boolean;
}

export function DocsLayout({
  tabs,
  currentTab,
  onTabChange,
  children,
  isSubPage = false,
}: DocsLayoutProps) {
  return (
    <PageContainer>
      <PageTitle variant="h4">Public Documentation</PageTitle>
      {tabs.length > 0 ? (
        <DocsTabs
          tabs={tabs}
          currentTab={currentTab}
          onChange={onTabChange}
          compact={isSubPage}
        />
      ) : null}
      {isSubPage ? <div style={{ marginTop: 24 }}>{children}</div> : children}
    </PageContainer>
  );
}
